import { themeClasses, type Theme } from "@cw/design-tokens/theme";
import { ContainedSection, SectionHeader } from "../primitives/Section";
export function Video({ heading, src, poster, caption, theme = "ink", id }: { heading?: string; src: string; poster?: string; caption?: string; theme?: Theme; id?: string }) {
  const t = themeClasses(theme);
  return (
    <ContainedSection theme={theme} id={id}>
      <SectionHeader heading={heading} theme={theme} align="center" />
      <figure className="mx-auto max-w-5xl">
        <video controls preload="metadata" poster={poster} className="aspect-video w-full rounded-card bg-black shadow-card">
          <source src={src} type="video/mp4" />
        </video>
        {caption ? <figcaption className={`${t.muted} mt-4 text-center text-sm`}>{caption}</figcaption> : null}
      </figure>
    </ContainedSection>
  );
}
